export const appHead = {"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.png"},{"rel":"manifest","href":"/manifest.webmanifest"},{"rel":"preconnect","href":"https://yt3.ggpht.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://res.cloudinary.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://sentry.io","crossorigin":"anonymous"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"hid":"description","name":"description","content":""},{"hid":"og:app_id","property":"og:app_id","content":"1470413516498692"},{"hid":"fb:app_id","property":"fb:app_id","content":"1470413516498692"},{"hid":"og:type","property":"og:type","content":"website"},{"name":"theme-color","content":"#004b9c"}],"style":[],"script":[{"hid":"defaultConsent","innerHTML":"(function() {function pushDataLayer() {if (!window.dataLayer) {window.dataLayer = []}window.dataLayer.push(arguments);if (!window.uetq) {window.uetq = []}window.uetq.push(...arguments);}pushDataLayer('consent','default',{\"ad_storage\":\"denied\",\"ad_user_data\":\"denied\",\"ad_personalization\":\"denied\",\"analytics_storage\":\"denied\"})})()","type":"text/javascript"},{"hid":"gtm","innerHTML":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                })(window,document,'script','dataLayer','GTM-TBSFGQS');","type":"text/javascript","defer":true}],"noscript":[],"title":"","titleTemplate":"","charset":"utf-8","viewport":"width=device-width, initial-scale=1, maximum-scale=5","bodyAttrs":{"class":"identity--rolfs"},"htmlAttrs":{}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"